import { AxiosError } from "axios";
import { apiUtils } from "api/common";

const IA_TIMEOUT_MS = 10 * 60 * 1000;

export async function postIa<T>(path: string, body: unknown): Promise<T> {
  try {
    const response = await apiUtils.post<T>(path, body, { timeout: IA_TIMEOUT_MS });
    return response.data;
  } catch (error) {
    throw toIaError(error);
  }
}

function toIaError(error: unknown): Error {
  if (error instanceof AxiosError) {
    const data = error.response?.data as { message?: string } | string | undefined;
    if (typeof data === "string" && data.trim()) {
      return new Error(data.trim());
    }
    if (data && typeof data === "object" && data.message?.trim()) {
      return new Error(data.message.trim());
    }
    if (error.code === "ECONNABORTED") {
      return new Error("Le serveur IA n'a pas répondu à temps.");
    }
  }
  return error instanceof Error ? error : new Error("Erreur IA");
}
